<div class="text-input">
  <!-- Label row with optional required indicator and helper text -->
  <div class="text-input__label-row">
    <label [for]="inputId()" class="text-input__label">{{ label() | translateLang }}@if (required()) {<span class="text-input__required-asterisk">*</span>}</label>
    @if (displayHelperText()) {
      <span class="text-input__helper-text">
        {{ displayHelperText() | translateLang : { max: maxlength() } }}
      </span>
    }
  </div>

  <!-- Conditional: input or textarea -->
  @if (inputType() === 'textarea') {
    <textarea
      pInputTextarea
      [id]="inputId()"
      [(ngModel)]="value"
      [placeholder]="placeholder() | translateLang"
      [disabled]="disabled()"
      [attr.maxlength]="maxlength()"
      [rows]="rows()"
      [attr.aria-label]="effectiveAriaLabel() | translateLang"
      [class.p-invalid]="isInvalid()"
      (blur)="onBlur()"
      (focus)="onFocus()"
      class="text-input__textarea"
    ></textarea>
  } @else {
    <input
      pInputText
      [type]="inputType()"
      [id]="inputId()"
      [(ngModel)]="value"
      [placeholder]="placeholder() | translateLang"
      [disabled]="disabled()"
      [attr.maxlength]="maxlength()"
      [attr.step]="step()"
      [attr.min]="min()"
      [attr.max]="max()"
      [attr.aria-label]="effectiveAriaLabel() | translateLang"
      [class.p-invalid]="isInvalid()"
      (blur)="onBlur()"
      (focus)="onFocus()"
      class="text-input__input"
    />
  }

  <!-- Error messages -->
  @if (isInvalid()) {
    <div class="text-input__error-message">
      @for (errorKey of getErrorKeys(); track errorKey) {
        <span class="text-input__error-item">
          {{ getErrorMessage(errorKey) | translateLang : getErrorParams(errorKey) }}
        </span>
      }
    </div>
  }
</div>
